const UNTRUSTED_TOOL_RESULT_TAG = /<\/?untrusted_tool_result(?:\s[^>]*)?>/gi;

/** Security wrappers guide the model; the enclosed failure detail remains useful. */
export const sanitizeComputerUseTraceDetail = (
  detail: string | undefined
): string | undefined => {
  const visibleDetail = detail?.replace(UNTRUSTED_TOOL_RESULT_TAG, '').trim();
  return visibleDetail || undefined;
};
